import { createI18n } from 'vue-i18n'

const messages = {
  'zh-CN': {
    common: {
      admin: '管理控制台',
      mail: 'Webmail',
      settings: '个人设置',
      planned: 'PLANNED BACKEND',
      refresh: '刷新',
      loading: '正在加载',
      unavailable: '依赖服务当前不可用',
      requestId: '请求 ID',
    },
    nav: {
      overview: '工作台',
      organizations: '组织与域名',
      mailboxes: '邮箱账号',
      routing: '路由与群组',
      security: '邮件安全',
      delivery: '队列与投递',
      audit: '日志与审计',
      system: '配置与系统',
    },
  },
  'en-US': {
    common: {
      admin: 'Admin Console',
      mail: 'Webmail',
      settings: 'Settings',
      planned: 'PLANNED BACKEND',
      refresh: 'Refresh',
      loading: 'Loading',
      unavailable: 'A required service is unavailable',
      requestId: 'Request ID',
    },
    nav: {
      overview: 'Workspace',
      organizations: 'Organizations & domains',
      mailboxes: 'Mailboxes',
      routing: 'Routing & groups',
      security: 'Mail security',
      delivery: 'Queue & delivery',
      audit: 'Logs & audit',
      system: 'Configuration & system',
    },
  },
}

export const i18n = createI18n({
  legacy: false,
  locale: 'zh-CN',
  fallbackLocale: 'en-US',
  messages,
})
